import Env from '../base/env';
import Channels from '../base/channels';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
gsap.registerPlugin(SplitText);
import { getCoords, scrollPosition } from '../utils/utilities';

export default () => ({
  ref: Env.$mainnav,
  items: Env.$mainnav.querySelectorAll('.css-entry'),
  fakeItems: document.querySelectorAll('.css-fake-entry'),
  subnavItems: Env.$mainnav.querySelectorAll('.css-subnav'),
  columnsScroll: Env.$mainnav.querySelectorAll('.js-column-scroll'),
  mousePosition: {},
  ZINDEX: 10,
  init() {
    this.setVars();
    this.watcher();
  },
  increaseZindex(e) {
    this.ZINDEX++;
    e.target.querySelector('collection-info').style.zIndex = this.ZINDEX;
  },
  events() {
    Env.$body.addEventListener('mousemove', (e) => {
      this.mousePosition = { x: e.clientX, y: e.clientY };
    });
    Channels.on('subnav::opened', () => {
      this.emitSubnavOpened();
    });
    Channels.on('mainnav::opened', () => {
      this.emitNavOpened();
    });
    Channels.on('mainnav::closed', () => {
      this.emitNavClosed();
    });
    Channels.on('window::smartresize', () => {
      this.reset();
      this.setVars();
    });
  },
  emitNavClosed() {
    this.emitSubnavClosed();
    this.closeAllSubnav();
    Env.$html.classList.remove('mainnav-opened');
  },
  closeAllSubnav(check) {
    for (const [i, item] of this.items.entries()) {
      if (check != item) {
        this.closeSubnavItem(item, i);
      }
    }
  },
  checkSubnav() {
    for (let item of this.items) {
      if (item.classList.contains('is-active')) {
        this.emitSubnavOpened();
        break;
      }
    }
  },
  closeSubnavItem(item, index) {
    this.emitSubnavClosed();
    item.classList.remove('is-active');
    if (typeof this.fakeItems[index] != 'undefined') {
      this.fakeItems[index].classList.remove('is-active');
    }
  },
  emitNavOpened() {
    Env.$html.classList.add('mainnav-opened');
  },
  emitSubnavClosed() {
    Env.$html.classList.remove('subnav-opened');
  },
  emitSubnavOpened() {
    Env.$html.classList.add('subnav-opened');
  },
  openSubnavItem(item, index) {
    const fakeItemActive = this.fakeItems[index];
    if (Env.mobileCSS) {
      item.classList.add('is-active');
      fakeItemActive.classList.add('is-active');
    } else {
      item.classList.toggle('is-active');
      fakeItemActive.classList.toggle('is-active');
      this.closeAllSubnav(item);
    }
    this.checkSubnav();
  },
  reset() {
    const doc = document.documentElement;
    doc.style.setProperty('--navopened-x', `0px`);
  },
  setVars() {
    const navOpenedX =
      Math.floor(
        getCoords(this.columnsScroll[0]).x - getCoords(this.items[0]).x
      ) + 48;
    const doc = document.documentElement;
    doc.style.setProperty('--navopened-x', `${navOpenedX}px`);
  },
  hideShowroom(e) {
    const elToHide =
      e.target.parentElement.parentElement.parentElement.querySelector(
        'showroom'
      );
    elToHide.classList.add('is-disabled');
  },
  showShowroom(e) {
    const elToHide =
      e.target.parentElement.parentElement.parentElement.querySelector(
        'showroom'
      );
    elToHide.classList.remove('is-disabled');
  },
  watcher() {
    this.raf = requestAnimationFrame(() => {
      if (
        (window.scrollObjectInstance.scroll > 200) &
        (this.mousePosition.y > 140)
      ) {
        Env.$html.classList.add('shortened-nav');
      } else {
        Env.$html.classList.remove('shortened-nav');
      }
      this.watcher();
    });
  },
});
